import React, {useEffect} from "react";
import ChoiceChips from "@app/react/components/BundleWizard/ChoiceChips.jsx";

function getBundle(bundleId, bundles) {
  return bundles.find(bundle => bundle.id === bundleId)
}

function getCategoryOptions(categories, bundles, selectedFrame, selectedVersion, selectedStyle) {
  const categoriesOptions = {
    frame: {},
    version: {},
    style: {}
  };

  const getAvailableIds = (categoryFieldName, depsCategoriesFields) => {
    return new Set(
      bundles
        .filter(bundle => {
          return depsCategoriesFields.every(depCategoryField =>
            !depCategoryField.value || bundle[depCategoryField.key].id === parseInt(depCategoryField.value)
          );
        })
        .map(bundle => bundle[categoryFieldName].id)
    );
  };

  const availableFrameIds = getAvailableIds('frame', [
    { key: 'version', value: selectedVersion },
    { key: 'style', value: selectedStyle }
  ]);

  const availableVersionIds = getAvailableIds('version', [
    { key: 'frame', value: selectedFrame },
    { key: 'style', value: selectedStyle }
  ]);

  const availableStyleIds = getAvailableIds('style', [
    { key: 'frame', value: selectedFrame },
    { key: 'version', value: selectedVersion }
  ]);

  const buildCategoryOptions = (categoryData, availableIds) => {
    const options = {};
    Object.keys(categoryData).forEach(id => {
      options[id] = {
        value: categoryData[id].id,
        name: categoryData[id].title,
        enabled: availableIds.has(parseInt(id))
      };
    });
    return options;
  };

  categoriesOptions.frame = buildCategoryOptions(categories.frame, availableFrameIds);
  categoriesOptions.version = buildCategoryOptions(categories.version, availableVersionIds);
  categoriesOptions.style = buildCategoryOptions(categories.style, availableStyleIds);

  return categoriesOptions;
}

export default function BundleSelection({categories, bundles, onSelect, defaultValue}) {
  const urlParams = new URLSearchParams(window.location.search);
  const defaultBundle = getBundle(defaultValue, bundles)
  const [selectedFrame, setSelectedFrame] = React.useState(defaultBundle?.frame.id ?? urlParams.get('frame') ?? '');
  const [selectedVersion, setSelectedVersion] = React.useState(defaultBundle?.version.id ?? '');
  const [selectedStyle, setSelectedStyle] = React.useState(defaultBundle?.style.id ?? '');

  const categoryOptions = getCategoryOptions(categories, bundles, selectedFrame, selectedVersion, selectedStyle);
  function findSelectedBundle() {
    for(const bundle of bundles) {
      if(bundle.frame.id === parseInt(selectedFrame)
          && bundle.version.id === parseInt(selectedVersion)
          && bundle.style.id === parseInt(selectedStyle))
      {
        return bundle;
      }
    }
    return null;
  }


  useEffect(() => {
    onSelect(findSelectedBundle())
  }, [selectedFrame, selectedVersion, selectedStyle]);

  return <>
    <div>
      <ChoiceChips label={Drupal.tt('telaio')} value={selectedFrame} choices={Object.values(categoryOptions.frame)} onChange={setSelectedFrame} />
    </div>
    <div>
      <ChoiceChips label={Drupal.tt('versione')} value={selectedVersion} choices={Object.values(categoryOptions.version)} onChange={setSelectedVersion} />
    </div>
    <div>
      <ChoiceChips label={Drupal.tt('stile')} value={selectedStyle} choices={Object.values(categoryOptions.style)} onChange={setSelectedStyle} />
    </div>
  </>
}
